const DEFAULT_PROD_API_BASE_URL = 'https://api.xjl888.top'

// API配置
export const API_CONFIG = {
  // 基础API URL
  // 生产环境默认使用正式 API 域名，也可通过 API_BASE_URL 覆盖
  BASE_URL:
    process.env.API_BASE_URL ||
    (process.env.NODE_ENV === 'production'
      ? DEFAULT_PROD_API_BASE_URL
      : '/api'),

  // 请求超时时间（毫秒）
  TIMEOUT: 10000,

  // 默认请求头
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  },
}
